import { Form, Row, Col, Input, Button, Card, Select, notification } from 'antd';
import React, { useState, useEffect } from "react";
import jsonfile from './budget.json';
import {CisUI} from '../../../../util/CISUI';
import 'react-smart-data-table/dist/react-smart-data-table.css';
import Config from "../../../../util/config";
import axios from "../../../../util/Api";
import {useHistory} from "react-router-dom";
import RemoteJson from "../../../../util/gerremotedata";
import $ from "jquery";
import InputOnly from "../../../../util/InputOnly";
import _ from "lodash";

import 'moment/locale/es-us';

const { Option } = Select;
// const Option = Select.Option;
const {TextArea} = Input;

const NewBudget = (props) => {

    const formRef = React.createRef();

    const [loading, setLoading] = useState([]);
    const [incomes, setInocmes] = useState([]);
    const [expenses, setExpenses] = useState([]);
    const [payable, setPayable] = useState([]);
    const [checked, setChecked] = useState([]);
    const [checkedpb, setCheckedPB] = useState([]);
    const [checkedExp, setCheckedExp] = useState([]);
    const [ttl, setTtl] = useState({
        totalIncome : 0,
        totalExpense : 0,
        totalPayable : 0
    });

    const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    const monthS = ["jan", "feb", "mar", "apr", "may", "jun",
        "jul", "aug", "sep", "oct", "nov", "dec"
    ];

    const [form] = Form.useForm();

    let endpoint = jsonfile.urls.add;
    const redirectto = "../../../"+jsonfile.urls.list;
    const history = useHistory();

    const handleChange=(e)=> {
        this.setState({
            [e.target.id]: e.target.value
        })
    }

    const userID = props.match.params.id;
    let userData = [];
   // console.log("Userid : "+props.match.params.id);
    let isEdit = 0;
    if(userID > 0) {
        isEdit = 1;
    }
    let Title = jsonfile.addtitle;
    if(isEdit === 1 ) {
        userData = RemoteJson(jsonfile.urls.view+"/"+userID);
        Title = jsonfile.edittitle;
        endpoint = jsonfile.urls.edit+"/"+userID;
    }

    const onFinish = (values) => {
        setLoading({loading:true})

        const incomesArray = incomes.filter(value => value.total > 0);
        const expenseArray = expenses.filter(valueX => valueX.total > 0);
        const payableArray = payable.filter(valueX => valueX.total > 0);

        //values['incomes'] = incomesArray;
        //values['expenses'] = expenseArray;
        values['allinput'] = [...incomesArray,...expenseArray,...payableArray];
        console.log("All Input : "+JSON.stringify(values));
        let msg = "Sorry! request not processed, please try again";
        document.getElementById("loader").style.display = "block";
        axios.post(Config.apiserver + endpoint, values)
            .then(res => {
                console.log(res)
                if(res.data.status === 1) {
                    notification.warning({
                        message: 'Alert',
                        type : "warning",
                        description: res.data.msg
                    });
                    history.push(redirectto);
                }
                else {
                    notification.warning({
                        message: 'Alert',
                        type : "warning",
                        description: res.data.msg
                    });
                }
                setLoading({loading:false});
                document.getElementById("loader").style.display = "none";
            })
            .catch(errors => {
                console.log(errors);
                // msg = (errors);
                setLoading({loading:false});
                //setResponse([]);
                // document.getElementById("loader").style.display = "none";
            });
    };

    //const dataOptions2 = SelectData("incomehead");
    //const dataOptions = SelectData("expensehead");

    useEffect(() => {
        getBudgetHead();
    }, []);

    let dataex = [];

    let dataex2 = [];

    let dataex3 = [];

    const getBudgetHead = async () => {
        return await axios.get("budgethead")
            .then((res) => {
                // console.log(res.data);
                if(res.data.status === 1) {
                    //setInocmes(res.data.incomes);
                    //setExpenses(res.data.expenses);

                    res.data.incomes.map((value, index) => {
                        dataex2[index] = {
                            id: value.id,
                            name: value.name,
                            total: null,
                            input: null,
                            jan : null,
                            feb : null,
                            mar : null,
                            apr : null,
                            may : null,
                            jun : null,
                            jul : null,
                            aug : null,
                            sep : null,
                            oct : null,
                            nov : null,
                            dec : null
                        };
                    });

                    dataex2[(res.data.incomes.length)] = {
                        id: 9999,
                        name: "Total Income",
                        total: null,
                        input: null,
                        jan : null,
                        feb : null,
                        mar : null,
                        apr : null,
                        may : null,
                        jun : null,
                        jul : null,
                        aug : null,
                        sep : null,
                        oct : null,
                        nov : null,
                        dec : null
                    };

                    setInocmes(dataex2);

                    res.data.expenses.map((value, index) => {
                        dataex[index] = {
                            id: value.id,
                            name: value.name,
                            total: null,
                            input: null,
                            jan : null,
                            feb : null,
                            mar : null,
                            apr : null,
                            may : null,
                            jun : null,
                            jul : null,
                            aug : null,
                            sep : null,
                            oct : null,
                            nov : null,
                            dec : null
                        };
                    });

                    dataex[(res.data.expenses.length)] = {
                        id: 9999,
                        name: "Total Expenses",
                        total: null,
                        input: null,
                        jan : null,
                        feb : null,
                        mar : null,
                        apr : null,
                        may : null,
                        jun : null,
                        jul : null,
                        aug : null,
                        sep : null,
                        oct : null,
                        nov : null,
                        dec : null
                    };

                    setExpenses(dataex);

                    res.data.payable.map((value, index) => {
                        dataex3[index] = {
                            id: value.id,
                            name: value.name,
                            total: null,
                            input: null,
                            jan : null,
                            feb : null,
                            mar : null,
                            apr : null,
                            may : null,
                            jun : null,
                            jul : null,
                            aug : null,
                            sep : null,
                            oct : null,
                            nov : null,
                            dec : null
                        };
                    });

                    dataex3[(res.data.payable.length)] = {
                        id: 9999,
                        name: "Total Payable",
                        total: null,
                        input: null,
                        jan : null,
                        feb : null,
                        mar : null,
                        apr : null,
                        may : null,
                        jun : null,
                        jul : null,
                        aug : null,
                        sep : null,
                        oct : null,
                        nov : null,
                        dec : null
                    };

                    setPayable(dataex3);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    //console.log("UserData : "+userData);

    const handleInputChange = (e, index) => {
        if(e && e.target) {
            const {name, value} = e.target;

            const list = [...incomes];
            //const list = [...incomes, { }];

            list[index]["id"] = incomes[index]["id"];
            list[index]["name"] = incomes[index]["name"];
            list[index]["total"] = value;
            list[index]["input"] = value;

            _.times(12, (i) => {
                list[index][monthS[i]] = incomes[index][monthS[i]] || null;
            });

            let total = 0;
            list.map((items,index)=>{
                if(total !== null) {
                    total += parseFloat(items.total || 0);
                }
            });

            setTtl({
                totalIncome : total,
                totalExpense : ttl.totalExpense,
                totalPayable : ttl.totalPayable
            });
            setInocmes(list);

        }
    };

    const  handleAmountInputChange = (e, index,i) => {
        if(e && e.target) {
            const list = [...incomes];
            list[index]["id"] = incomes[index]["id"];
            list[index]["name"] = incomes[index]["name"];

            let ttls = 0;
            _.times(12, (ix) => {
                if(ix === i) {
                    list[index][monthS[ix]] = parseFloat(e.target.value || 0) || null;
                    ttls += parseFloat(e.target.value || 0);
                }
                else {
                    list[index][monthS[ix]] = incomes[index][monthS[ix]] || null;
                    ttls += parseFloat(incomes[index][monthS[ix]] || 0);
                }

            });

            list[index]["total"] = ttls;
            list[index]["input"] = incomes[index]["input"];

            let total = 0;
            list.map((items,index)=>{
                if(items.total !== null) {
                    total += parseFloat(items.total);
                }
            });

            setTtl({
                totalIncome : total,
                totalExpense : ttl.totalExpense,
                totalPayable : ttl.totalPayable
            });

            setInocmes(list);
        }
    };

    const handlePayableChange = (e, index) => {
        if(e && e.target) {
            const {name, value} = e.target;

            const list = [...payable];
            //const list = [...incomes, { }];

            list[index]["id"] = payable[index]["id"];
            list[index]["name"] = payable[index]["name"];
            list[index]["total"] = value;
            list[index]["input"] = value;

            _.times(12, (i) => {
                list[index][monthS[i]] = payable[index][monthS[i]] || null;
            });

            let total = 0;
            list.map((items,index)=>{
                if(total !== null) {
                    total += parseFloat(items.total || 0);
                }
            });

            setTtl({
                totalIncome : ttl.totalIncome,
                totalExpense : ttl.totalExpense,
                totalPayable : total
            });

            setPayable(list);

        }
    };

    const  handlePayableInputChange = (e, index,i) => {
        if(e && e.target) {
            const list = [...payable];
            list[index]["id"] = payable[index]["id"];
            list[index]["name"] = payable[index]["name"];

            let ttls = 0;
            _.times(12, (ix) => {
                if(ix === i) {
                    list[index][monthS[ix]] = parseFloat(e.target.value || 0) || null;
                    ttls += parseFloat(e.target.value || 0);
                }
                else {
                    list[index][monthS[ix]] = payable[index][monthS[ix]] || null;
                    ttls += parseFloat(payable[index][monthS[ix]] || 0);
                }

            });

            list[index]["total"] = ttls;
            list[index]["input"] = incomes[index]["input"];

            let total = 0;
            list.map((items,index)=>{
                if(items.total !== null) {
                    total += parseFloat(items.total);
                }
            });

            setTtl({
                totalIncome : ttl.totalIncome,
                totalExpense : ttl.totalExpense,
                totalPayable : total
            });

            setPayable(list);
        }
    };

    const m_handleInputChange = (e, index) => {
        if(e && e.target) {
            const {name, value} = e.target;
            const list = [...expenses];

            list[index]["id"] = expenses[index]["id"];
            list[index]["name"] = expenses[index]["name"];
            list[index]["total"] = value;
            list[index]["input"] = value;

            _.times(12, (i) => {
                list[index][monthS[i]] = expenses[index][monthS[i]] || null;
            });

            let total = 0;
            list.map((items,index)=>{
                if(items.total !== null) {
                    total += parseFloat(items.total);
                }
            });

            setTtl({
                totalIncome : ttl.totalIncome,
                totalExpense : total,
                totalPayable : ttl.totalPayable
            });

            setExpenses(list);

        }
    };

    const  m_handleAmountInputChange = (e, index,i) => {
        if(e && e.target) {
            const list = [...expenses];
            list[index]["id"] = expenses[index]["id"];
            list[index]["name"] = expenses[index]["name"];
            //list[index]["total"] = expenses[index]["total"];

            let ttls = 0;
            _.times(12, (ix) => {
                if(ix === i) {
                    list[index][monthS[ix]] = parseFloat(e.target.value || 0);
                    ttls += parseFloat(e.target.value || 0);
                }
                else {
                    list[index][monthS[ix]] = expenses[index][monthS[ix]] || 0;
                    ttls += parseFloat(expenses[index][monthS[ix]] || 0);
                }

            });

            list[index]["total"] = ttls;
            list[index]["input"] = expenses[index]["input"];

            let total = 0;
            list.map((items,index)=>{
                total += parseFloat(items.total);
            });

            setTtl({
                totalIncome : ttl.totalIncome,
                totalExpense : total,
                totalPayable : ttl.totalPayable
            });

            setExpenses(list);
        }
    };

    $('#input_region_id').on('change', function() {
        alert( "Regeion Selected" );
    });

    const onCheck = (e) => {
        let ck = [...checked];
        //console.log(ck)
        const vl = e?.target.value;
        //console.log(ck.indexOf(vl));
        if(ck.includes(parseInt(vl))) {
            const index = ck.indexOf(vl);
            ck.splice(index,1);
            // console.log('1st', ck, index);

            console.log("checked found :",ck);
        }
        else {
            // console.log(vl)
            //ck.filter(Boolean);
            ck.push(parseInt(vl));
            console.log("checked value :",ck);
        }

        setChecked(ck);

    }

    const onCheckPayable = (e) => {
        let ck = [...checkedpb];
        //console.log(ck)
        const vl = e?.target.value;
        //console.log(ck.indexOf(vl));
        if(ck.includes(parseInt(vl))) {
            const index = ck.indexOf(vl);
            ck.splice(index,1);
            // console.log('1st', ck, index);

            console.log("checked found :",ck);
        }
        else {
            // console.log(vl)
            //ck.filter(Boolean);
            ck.push(parseInt(vl));
            console.log("checked value :",ck);
        }

        setCheckedPB(ck);

    }

    const onCheckExp = (e) => {
        let ck = [...checkedExp];
        //console.log(ck)
        const vl = e?.target.value;
        //console.log(ck.indexOf(vl));
        if(ck.includes(parseInt(vl))) {
            const index = ck.indexOf(vl);
            ck.splice(index,1);
            // console.log('1st', ck, index);

            console.log("checked found :",ck);
        }
        else {
            // console.log(vl)
            //ck.filter(Boolean);
            ck.push(parseInt(vl));
            console.log("checked value :",ck);
        }

        setCheckedExp(ck);
    }

    const onFillClick = () => {
        if(checked.length > 0) {

            const list = [...incomes];

            checked.map((value,index) => {
                const data = incomes[value];
                list[value]["id"] = incomes[value]["id"];
                list[value]["name"] = incomes[value]["name"];
                let total = 0;
                _.times(12, (ix) => {
                    list[value][monthS[ix]] = incomes[value]["input"] || null;
                    total += parseFloat(incomes[value]["input"]) || null;
                });
                list[value]["total"] = total || null;
                list[value]["input"] = incomes[value]["input"] || null;

            });

            let total = 0;
            list.map((items,index)=>{
                if(items.total !== null) {
                    total += parseFloat(items.total);
                }
            });

            setTtl({
                totalIncome : total,
                totalExpense : ttl.totalExpense,
                totalPayable : ttl.totalPayable
            });

            setInocmes(list);

        }
        else {
            notification.warning({
                message: 'Alert',
                type : "warning",
                description: "Sorry you did not select any items"
            });
        }
    }

    const onDistributeClick = () => {
        if(checked.length > 0) {

            const list = [...incomes];
            // const list = incomes;
            checked.map((value,index) => {
                const data = incomes[value];
                list[value]["id"] = incomes[value]["id"];
                list[value]["name"] = incomes[value]["name"];
                list[value]["total"] = incomes[value]["input"] || null;
                list[value]["input"] = incomes[value]["input"] || null;
                const eachV = incomes[value]["total"] / 12;
                _.times(12, (ix) => {
                    list[value][monthS[ix]] = eachV.toFixed(2) || null;
                });
            });

            let total = 0;
            list.map((items,index)=>{
                if(items.total !== null) {
                    total += parseFloat(items.total);
                }
            });

            setTtl({
                totalIncome : total,
                totalExpense : ttl.totalExpense,
                totalPayable : ttl.totalPayable
            });

            setInocmes(list);

        }
        else {
            notification.warning({
                message: 'Alert',
                type : "warning",
                description: "Sorry you did not select any items"
            });
        }
    }

    const onFillClickExp = () => {
        if(checkedExp.length > 0) {

            const list = [...expenses];

            checkedExp.map((value,index) => {
                const data = expenses[value];
                list[value]["id"] = expenses[value]["id"];
                list[value]["name"] = expenses[value]["name"];
                let total = 0;
                _.times(12, (ix) => {
                    list[value][monthS[ix]] = expenses[value]["input"] || null;
                    total += parseFloat(expenses[value]["input"]) || null;
                });
                list[value]["total"] = total || null;
                list[value]["input"] = expenses[value]["input"] || null;

            });

            let total = 0;
            list.map((items,index)=>{
                if(items.total !== null) {
                    total += parseFloat(items.total);
                }
            });

            setTtl({
                totalIncome : ttl.totalIncome,
                totalExpense : total,
                totalPayable : ttl.totalPayable
            });

            setExpenses(list);

        }
        else {
            notification.warning({
                message: 'Alert',
                type : "warning",
                description: "Sorry you did not select any items"
            });
        }
    }

    const onDistributeClickExp = () => {
        if(checkedExp.length > 0) {

            const list = [...expenses];
            checkedExp.map((value,index) => {
                const data = expenses[value];
                list[value]["id"] = expenses[value]["id"];
                list[value]["name"] = expenses[value]["name"];
                list[value]["total"] = expenses[value]["input"] || null;
                list[value]["input"] = expenses[value]["input"] || null;
                const eachV = expenses[value]["total"] / 12;
                _.times(12, (ix) => {
                    list[value][monthS[ix]] = eachV.toFixed(2) || null;
                });
            });

            let total = 0;
            list.map((items,index)=>{
                if(items.total !== null) {
                    total += parseFloat(items.total);
                }
            });

            setTtl({
                totalIncome : ttl.totalIncome,
                totalExpense : total,
                totalPayable : ttl.totalPayable
            });

            setExpenses(list);

        }
        else {
            notification.warning({
                message: 'Alert',
                type : "warning",
                description: "Sorry you did not select any items"
            });
        }
    }

    const onFillClickPay = () => {
        if(checkedpb.length > 0) {

            const list = [...payable];

            checkedpb.map((value,index) => {
                const data = payable[value];
                list[value]["id"] = payable[value]["id"];
                list[value]["name"] = payable[value]["name"];
                let total = 0;
                _.times(12, (ix) => {
                    list[value][monthS[ix]] = payable[value]["input"] || null;
                    total += parseFloat(payable[value]["input"]) || null;
                });
                list[value]["total"] = total || null;
                list[value]["input"] = payable[value]["input"] || null;

            });

            let total = 0;
            list.map((items,index)=>{
                if(items.total !== null) {
                    total += parseFloat(items.total);
                }
            });

            setTtl({
                totalIncome : ttl.totalIncome,
                totalExpense : ttl.totalExpense,
                totalPayable : total
            });

            setPayable(list);

        }
        else {
            notification.warning({
                message: 'Alert',
                type : "warning",
                description: "Sorry you did not select any items"
            });
        }
    }

    const onDistributeClickPay = () => {
        if(checkedpb.length > 0) {

            const list = [...payable];
            checkedpb.map((value,index) => {
                const data = payable[value];
                list[value]["id"] = payable[value]["id"];
                list[value]["name"] = payable[value]["name"];
                list[value]["total"] = payable[value]["input"] || null;
                list[value]["input"] = payable[value]["input"] || null;
                const eachV = payable[value]["total"] / 12;
                _.times(12, (ix) => {
                    list[value][monthS[ix]] = eachV.toFixed(2) || null;
                });
            });

            let total = 0;
            list.map((items,index)=>{
                if(items.total !== null) {
                    total += parseFloat(items.total);
                }
            });

            setTtl({
                totalIncome : ttl.totalIncome,
                totalExpense : ttl.totalExpense,
                totalPayable : total
            });

            setPayable(list);

        }
        else {
            notification.warning({
                message: 'Alert',
                type : "warning",
                description: "Sorry you did not select any items"
            });
        }
    }

    const onMarkAll = () => {
        let ck = [];
        incomes.map((items,index) => {
            ck.push(index);
        })
        setChecked(ck);
    }

    const onMarkAllExp = () => {
        let ck = [];
        expenses.map((items,index) => {
            ck.push(index);
        })
        setCheckedExp(ck);
    }

    const onUnMarkAll = () => {
        setChecked([]);
    }

    const onUnMarkAllExp = () => {
        setCheckedExp([]);
    }

    const onMarkAllPay = () => {
        let ck = [];
        payable.map((items,index) => {
            ck.push(index);
        })
        setCheckedPB(ck);
    }

    const onUnMarkAllPay = () => {
        setCheckedPB([]);
    }

    return (
        <Card title={Title}>
            {
                isEdit === 1
                    ? CisUI().addAction("../../"+jsonfile.urls.list)
                    : CisUI().addAction("../"+jsonfile.urls.list)
            }
            {CisUI().showLoading}
            <Form
                form={form}
                ref={formRef}
                {...CisUI().formItemLayout}
                name="input"
                className="ant-advanced-search-form"
                onFinish={onFinish}
            >
                {
                    CisUI().getUserInfo('comarea') <=3 ? InputOnly(jsonfile.inputAdmin,userData,isEdit) : InputOnly(jsonfile.input,userData,isEdit)
                }

                <Row gutter={24}>
                    <div className="table-responsive" style={{overflow: "auto"}}>
                        <h4>Incomes </h4>
                        <button type="button" onClick={onFillClick} className="btn btn-primary">Fill</button>
                        <button type="button" onClick={onDistributeClick} className="btn btn-primary">Distribute</button>
                        <button type="button" onClick={onMarkAll} className="btn btn-primary">Mark All</button>
                        <button type="button" onClick={onUnMarkAll} className="btn btn-outline-info">Unmark All</button>
                        <table className="table table-bordered">
                            <thead>
                            <tr>
                                <th></th>
                                <th style={{width : "300px"}}>Account Name</th>
                                <th style={{width : "80px"}}>Total</th>
                                {_.times(12, (i) => (
                                    <td style={{width : "60px"}} key={i}>{monthNames[i]}</td>
                                ))}
                            </tr>
                            </thead>

                            {incomes.map((x, index) => {
                                return (
                                    <>
                                        <tr>
                                            <th>
                                                <input type="checkbox" checked={checked.filter(items => items === index).length === 1} onClick={onCheck} name="ck" id={"ck_"+x.id} value={index} />
                                            </th>
                                            <td>{x.name}
                                                <input type="hidden" id={"income_"+x.id} name="income" value={x.id} />
                                            </td>
                                            <td style={{width : "80px"}}>
                                                <input
                                                    className="ant-input"
                                                    name="total"
                                                    value={incomes[index].total}
                                                    style={{width : "60px"}}
                                                    id={"total_"+x.id+"_"+index}
                                                    onChange={e => handleInputChange(e, index)}
                                                />
                                            </td>
                                            {_.times(12, (i) => (
                                                <td style={{width : "60px"}}>
                                                    <input
                                                        className="ant-input"
                                                        name={"amount"}
                                                        value={incomes[index][monthS[i]]}
                                                        style={{width : "60px"}}
                                                        id={"amount_"+x.id+"_"+index}
                                                        onChange={e => handleAmountInputChange(e, index,i)}
                                                    />
                                                </td>
                                            ))}
                                        </tr>
                                    </>
                                );
                            })}
                        </table>

                        <h4>Expenses </h4>
                        <button type="button" onClick={onFillClickExp} className="btn btn-primary">Fill</button>
                        <button type="button" onClick={onDistributeClickExp} className="btn btn-primary">Distribute</button>
                        <button type="button" onClick={onMarkAllExp} className="btn btn-primary">Mark All</button>
                        <button type="button" onClick={onUnMarkAllExp} className="btn btn-outline-info">Unmark All</button>
                        <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th></th>
                                <th style={{width : "300px"}}>Account Name</th>
                                <th style={{width : "80px"}}>Total</th>
                                {_.times(12, (i) => (
                                    <td style={{width : "60px"}} key={i}>{monthNames[i]}</td>
                                ))}
                            </tr>
                        </thead>

                        {expenses.map((x, i) => {
                            return (
                                <>
                                    <tr>
                                        <th>
                                            <input type="checkbox" checked={checkedExp.filter(items => items === i).length === 1} onClick={onCheckExp} name="ck" id={"ck_"+x.id} value={i} />
                                        </th>
                                        <td>{x.name}
                                            <input type="hidden" id={"expensetype_"+x.id} name="expensetype" value={x.id} />
                                        </td>
                                        <td style={{width : "80px"}}>
                                            <input
                                                className="ant-input"
                                                name="total"
                                                value={expenses[i]["total"]}
                                                style={{width : "60px"}}
                                                id={"total_"+x.id+"_"+i}
                                                onChange={e => m_handleInputChange(e, i)}
                                            />
                                        </td>
                                        {_.times(12, (ix) => (
                                            <td style={{width : "60px"}}>
                                                <input
                                                    className="ant-input"
                                                    name="amount"
                                                    value={expenses[i][monthS[ix]]}
                                                    style={{width : "60px"}}
                                                    id={"amount_"+x.id+"_"+ix}
                                                    onChange={e => m_handleAmountInputChange(e, i,ix)}
                                                />
                                            </td>
                                        ))}
                                    </tr>
                                </>
                            );
                        })}

                    </table>

                        <h4>Payable </h4>
                        <button type="button" onClick={onFillClickPay} className="btn btn-primary">Fill</button>
                        <button type="button" onClick={onDistributeClickPay} className="btn btn-primary">Distribute</button>
                        <button type="button" onClick={onMarkAllPay} className="btn btn-primary">Mark All</button>
                        <button type="button" onClick={onUnMarkAllPay} className="btn btn-outline-info">Unmark All</button>
                        <table className="table table-bordered">
                            <thead>
                            <tr>
                                <th></th>
                                <th style={{width : "300px"}}>Account Name</th>
                                <th style={{width : "80px"}}>Total</th>
                                {_.times(12, (i) => (
                                    <td style={{width : "60px"}} key={i}>{monthNames[i]}</td>
                                ))}
                            </tr>
                            </thead>

                            {payable.map((x, index) => {
                                return (
                                    <>
                                        <tr>
                                            <th>
                                                <input type="checkbox" checked={checkedpb.filter(items => items === index).length === 1} onClick={onCheckPayable} name="ck" id={"ck_"+x.id} value={index} />
                                            </th>
                                            <td>{x.name}
                                                <input type="hidden" id={"payable_"+x.id} name="payable" value={x.id} />
                                            </td>
                                            <td style={{width : "80px"}}>
                                                <input
                                                    className="ant-input"
                                                    name="total"
                                                    value={payable[index].total}
                                                    style={{width : "60px"}}
                                                    id={"total_"+x.id+"_"+index}
                                                    onChange={e => handlePayableChange(e, index)}
                                                />
                                            </td>
                                            {_.times(12, (i) => (
                                                <td style={{width : "60px"}}>
                                                    <input
                                                        className="ant-input"
                                                        name={"amount"}
                                                        value={payable[index][monthS[i]]}
                                                        style={{width : "60px"}}
                                                        id={"amount_"+x.id+"_"+index}
                                                        onChange={e => handlePayableInputChange(e, index,i)}
                                                    />
                                                </td>
                                            ))}
                                        </tr>
                                    </>
                                );
                            })}
                        </table>

                    </div>
                </Row>

                <Row gutter={24} className="bottomFixed">
                    <div className="col-md-12" style={{marginTop : '15px', fontWeight: 'bold', padding: '5px'}}>
                        <div className="row">
                            <div className="col-md-3">
                                Total Incomes : {CisUI().getCurrencyFormated1(ttl.totalIncome)}
                            </div>
                            <div className="col-md-3">
                                Total Expenses : {CisUI().getCurrencyFormated1(ttl.totalExpense)}
                            </div>
                            <div className="col-md-3">
                                {(ttl.totalIncome - ttl.totalExpense) > 0 ? "Surplus" : "Deficit"} : {CisUI().getCurrencyFormated1(ttl.totalIncome - ttl.totalExpense)}
                            </div>
                            <div className="col-md-3">
                                Total Payable : {CisUI().getCurrencyFormated1(ttl.totalPayable)}
                            </div>
                        </div>
                    </div>
                    <Col lg={24} md={24} sm={12} xs={24} style={{textAlign: 'center'}}>
                        <Button id="submitbutton" type="primary" htmlType="submit">
                            Submit
                        </Button>
                        <Button type="info" onClick={() => history.goBack()} htmlType="back">Cancel</Button>
                    </Col>
                </Row>

            </Form>

        </Card>
    );
};

export default NewBudget;